import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { VipPackage } from '../../../../core/models/announcement.model';
import { VipService } from '../../../../core/services/vip.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-vip-upgrade-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="modal-backdrop" (click)="onClose.emit()">
      <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h3>VIP xidmətini seçin</h3>
          <button class="close-btn" (click)="onClose.emit()">&times;</button>
        </div>

        <div class="modal-body">
          <div class="packages-grid">
            <div class="package-card" *ngFor="let pkg of packages"
                 [class.selected]="selectedPackage?.id === pkg.id"
                 (click)="selectedPackage = pkg">
              <div class="pkg-days">{{ pkg.days }} gün</div>
              <div class="pkg-price">{{ pkg.price | number:'1.2-2' }} ₼</div>
            </div>
          </div>

          <div class="payment-section" *ngIf="selectedPackage">
            <h4>Ödəniş məlumatları</h4>
            <div class="form-group">
              <input type="text" [(ngModel)]="paymentData.cardNumber" placeholder="Kart nömrəsi" class="form-input">
            </div>
            <div class="form-row">
              <input type="text" [(ngModel)]="paymentData.expiry" placeholder="AA/İİ" class="form-input">
              <input type="text" [(ngModel)]="paymentData.cvv" placeholder="CVV" class="form-input">
            </div>
          </div>

          <div class="error-message" *ngIf="error">
            {{ error }}
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn-cancel" (click)="onClose.emit()">Ləğv et</button>
          <button class="btn-submit" [disabled]="!selectedPackage || isLoading" (click)="confirmPayment()">
            {{ isLoading ? 'Gözləyin...' : 'Ödənişi təsdiqlə' }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .modal-backdrop {
      position: fixed;
      top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0,0,0,0.5);
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
    }
    .modal-card {
      background: white;
      width: 100%;
      max-width: 500px;
      border-radius: 16px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
    .modal-header {
      padding: 20px;
      border-bottom: 1px solid #f1f2f6;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .modal-header h3 { margin: 0; font-size: 20px; }
    .close-btn { background: none; border: none; font-size: 24px; cursor: pointer; color: #b2bec3; }
    .modal-body { padding: 20px; display: flex; flex-direction: column; gap: 24px; }
    .packages-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }
    .package-card {
      border: 2px solid #f1f2f6;
      border-radius: 12px;
      padding: 16px;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s;
    }
    .package-card.selected {
      border-color: #6c5ce7;
      background: #f3f0ff;
    }
    .pkg-days { font-weight: 700; font-size: 18px; margin-bottom: 4px; }
    .pkg-price { color: #6c5ce7; font-weight: 600; }
    .payment-section { display: flex; flex-direction: column; gap: 12px; }
    .payment-section h4 { margin: 0; font-size: 16px; }
    .form-group { width: 100%; }
    .form-row { display: flex; gap: 12px; }
    .form-input {
      width: 100%;
      padding: 12px;
      border: 1px solid #dfe6e9;
      border-radius: 8px;
      font-size: 16px;
    }
    .modal-footer {
      padding: 20px;
      border-top: 1px solid #f1f2f6;
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    }
    .btn-cancel { padding: 12px 24px; border: none; background: #f1f2f6; color: #2d3436; border-radius: 8px; font-weight: 600; cursor: pointer; }
    .btn-submit { padding: 12px 24px; border: none; background: #6c5ce7; color: white; border-radius: 8px; font-weight: 600; cursor: pointer; }
    .btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }
    .error-message { color: #d63031; font-size: 14px; text-align: center; }
  `]
})
export class VipUpgradeModalComponent {
  @Input() listingId!: string;
  @Input() packages: VipPackage[] = [];
  @Output() onSuccess = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();

  private vipService = inject(VipService);

  selectedPackage: VipPackage | null = null;
  paymentData = { cardNumber: '', expiry: '', cvv: '' };
  isLoading = false;
  error: string | null = null;

  confirmPayment() {
    if (!this.selectedPackage) return;

    this.isLoading = true;
    this.error = null;

    this.vipService.purchaseVipPackage(this.listingId, this.selectedPackage.id, this.paymentData)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (success) => {
          if (success) {
            this.onSuccess.emit();
          } else {
            this.error = 'Ödəniş zamanı xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.';
          }
        },
        error: () => {
          this.error = 'Server xətası baş verdi.';
        }
      });
  }
}
